// src/core/services/store/admin/notifications.module.js

import ApiService from "@/core/services/api.service";

// Action Types
export const FETCH_ADMIN_NOTIFICATIONS = "fetchAdminNotifications";
export const CREATE_ADMIN_NOTIFICATION = "createAdminNotification";
export const RESOLVE_ADMIN_NOTIFICATION_CELLPHONES =
  "resolveAdminNotificationCellphones";

// Mutation Types
export const SET_ADMIN_NOTIFICATIONS = "setAdminNotifications";
export const SET_ADMIN_NOTIFICATIONS_PAGINATION =
  "setAdminNotificationsPagination";

const state = {
  notifications: [],
  pagination: {
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 15,
  },
};

const getters = {
  adminNotifications: (state) => state.notifications,
  adminNotificationsPagination: (state) => state.pagination,
};

const actions = {
  [FETCH_ADMIN_NOTIFICATIONS](context, payload = {}) {
    let params = {
      page: context.state.pagination.current_page || 1,
    };

    if (payload.page) {
      params.page = payload.page;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("admin/notifications", { params })
        .then(({ data }) => {
          const notifications = data.data || data.notifications || data || [];
          const meta = data.meta || data.pagination || {};

          context.commit(SET_ADMIN_NOTIFICATIONS, notifications);
          context.commit(SET_ADMIN_NOTIFICATIONS_PAGINATION, {
            total: meta.total || data.total || notifications.length || 0,
            current_page:
              meta.current_page || data.current_page || params.page || 1,
            last_page: meta.last_page || data.last_page || 1,
            per_page: meta.per_page || data.per_page || 15,
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [CREATE_ADMIN_NOTIFICATION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/notifications", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [RESOLVE_ADMIN_NOTIFICATION_CELLPHONES](context, cellphones) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        "admin/notifications/resolve-cellphones",
        { cellphones },
        null,
        false
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
};

const mutations = {
  [SET_ADMIN_NOTIFICATIONS](state, list) {
    state.notifications = list;
  },
  [SET_ADMIN_NOTIFICATIONS_PAGINATION](state, pagination) {
    state.pagination = pagination;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
